// Include jQuery plugins
//require('jquery.sample');

// Import non-jQuery modules
//const sample = require('sample');

// Define wp_localize_script handles
/* global nisch, handorgel */

(function($) {
    const wntrTheme = {
        body: $('body'),
        html: $('html'),
        document: $(document),

        setCookie: function(cname, cvalue, exdays) {
            const d = new Date();
            d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            const expires = "expires=" + d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        },

        getCookie: function(cname) {
            const name = cname + "=";
            const decodedCookie = decodeURIComponent(document.cookie);
            const ca = decodedCookie.split(';');
            for(let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while(c.charAt(0) === ' ') {
                    c = c.substring(1);
                }
                if(c.indexOf(name) === 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        },

        /**
         * Initialise theme JS on page load
         */
        init: function() {
            // Do we have JS?
            $('html').removeClass('no-js');

            // Remove region param from url
            if(window.location.href.indexOf('region_code') > -1) {
                window.history.pushState('', '', '/');
            }

            // Automatically call all methods that start with __, in the order they're defined
            for(const prop in wntrTheme) {
                if(prop.startsWith('__') && typeof wntrTheme[prop] === 'function') {
                    wntrTheme[prop].call();
                }
            }
        },

        /**
         * Initlize handorgel accordions
         */
        __initAccordions: () => {
            if(wntrTheme.body.find('.handorgel').length > 0) {
                $.each(wntrTheme.body.find('.handorgel'), function() {
                    new handorgel($(this)[0]);
                });
            }
        },

        /**
         * Cookie consent bar handler
         */
        __cookieConsentHandler: () => {
            if(!wntrTheme.getCookie('uesr_has_closed_cookie_banner')) {
                wntrTheme.body.addClass('cookie-banner-active');
            }

            const cookieBanner = wntrTheme.body.children('.cookie-consent').first();

            if(cookieBanner.length && wntrTheme.body.hasClass('cookie-banner-active')) {

                cookieBanner.find('.cookie-consent__button').on('click', () => {
                    wntrTheme.body.removeClass('cookie-banner-active');
                    wntrTheme.setCookie('uesr_has_closed_cookie_banner', 'true', 30);
                });
            }
        },

        /**
         * Dropdown / submenu handler
         */
        __submenuHandler: () => {
            const dropdownToggle = wntrTheme.body.find('.menu-item-has-children');

            if(!dropdownToggle.length) {
                return false;
            }

            const submenu = wntrTheme.body.find('.sub-menu');

            // desktop
            if($(window).width() > 1024) {

                // open menu on tabbing
                wntrTheme.body.find('.menu-item-has-children a').on('focus', function() {
                    $(this).parent('.menu-item-has-children').find('.sub-menu').addClass('is-active');
                });

                // close menu on 'body' click, but not inside of submenu
                wntrTheme.body.on('mousedown', function(e) {
                    if(!$(e.target).closest('.sub-menu').length && submenu.hasClass('is-active')) {
                        submenu.removeClass('is-active');
                    }
                });

                // close menu on press esc
                wntrTheme.body.on('keydown', function(e) {
                    if(e.key === "Escape" && submenu.hasClass('is-active')) {
                        submenu.removeClass('is-active');
                    }
                });

                // close menu after tabbing last link
                submenu.find('li:last-of-type > a').on('keydown', function(e) {
                    if(e.shiftKey && e.keyCode === 9) {
                        submenu.addClass('is-active');
                    } else if(e.keyCode === 9) {
                        submenu.removeClass('is-active');
                    }
                });

                // close on mouse out
                submenu.on('mouseout', function() {
                    submenu.removeClass('is-active');
                });

                // open current menu on mouse in
                dropdownToggle.on('mouseover', function() {
                    $(this).find('.sub-menu').addClass('is-active');
                });

                // open current menu on mouse in
                dropdownToggle.on('mouseout', function() {
                    $(this).find('.sub-menu').removeClass('is-active');
                });

            } else {
                dropdownToggle.on('click', function() {
                    $(this).find('.toggle-sub-menu').toggleClass('is-active');
                    $(this).find('.sub-menu').slideToggle(150);
                });

            }
        },

        /**
         * Location selector handler
         */
        __locationSelectorHandler: () => {
            const selector = wntrTheme.body.find('.casino-geo__selector');
            if(selector.length) {
                selector.on('change', function() {
                    window.location.href = nisch.home_url + '?region_code=' + $(this).val();
                    return;
                });
            }
        },

        /**
         * Matchheight init
         */
        __doMatchHeight: () => {
            if(wntrTheme.body.find('.news__content').length) {
                wntrTheme.body.find('.news__content').matchHeight();
            }
        },

        __clickEventHandlers() {
            wntrTheme.body.find('.header__toggle').on('click', function() {
                $(this).toggleClass('is-active');
                wntrTheme.body.find('.header__mobile-menu').toggleClass('is-active');
                wntrTheme.body.toggleClass('menu-active');
                wntrTheme.body.toggleClass('is-fixed');

                if(wntrTheme.body.hasClass('language-modal-active')) {
                    wntrTheme.body.removeClass('language-modal-active');
                    wntrTheme.body.find('.header__lang-switcher-modal').removeClass('is-active');
                }
            });

            wntrTheme.body.find('.header__lang-switcher a').on('click', function(e) {
                e.preventDefault();
                wntrTheme.body.find('.header__lang-switcher-modal').toggleClass('is-active');
                wntrTheme.body.toggleClass('language-modal-active');

                if(wntrTheme.body.hasClass('menu-active')) {
                    wntrTheme.body.removeClass('menu-active');
                    wntrTheme.body.find('.header__mobile-menu').removeClass('is-active');
                    wntrTheme.body.removeClass('is-fixed');
                    wntrTheme.body.find('.header__toggle').removeClass('is-active');
                }
            });

            wntrTheme.body.find('.header__lang-switcher-modal button').on('click', function() {
                wntrTheme.body.find('.header__lang-switcher-modal').toggleClass('is-active');
                wntrTheme.body.toggleClass('language-modal-active');
            });
        },
    };

    $(document).ready(wntrTheme.init);
})(jQuery);